import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    colorMode: 'light',
}

export const themeSlice = createSlice({
    name: 'theme',
    initialState: initialState,
    reducers: {
        setColorMode: (state, action) => {
            state.colorMode = action.payload;
            localStorage.setItem("colorMode", action.payload);
        },
        changeColorMode: (state, action) => {
            state.colorMode = action.payload;
            localStorage.setItem("colorMode", action.payload);
            window.location.reload();
        }
    }
})

export const { setColorMode, changeColorMode } = themeSlice.actions;

export default themeSlice.reducer;
